import * as types from './mutation-types'
import {  API_STATES } from '@/helpers'
import { each ,findIndex,find } from 'lodash'

const parseToTwoDecimal = statistics => {
  each(statistics, (val, key) => {
    statistics[key] = Number.isInteger(val) ? val : !isNaN(parseFloat(val)) ? val.toFixed(2) : val
  })

  return statistics
}

const mutations = {
  // getSchedules
  [types.GET_MY_SCHEDULES_BEGIN](state) {
    state.mySchedulesState = API_STATES.REQUEST_PENDING
  },
  [types.GET_MY_SCHEDULES_SUCCESS](state, appUser) {
    state.mySchedulesError = null
    state.mySchedules = appUser
    state.mySchedulesState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_MY_SCHEDULES_ERROR](state, err) {
    state.mySchedulesState = API_STATES.REQUEST_ERROR
    state.mySchedulesError = err
  },

  [types.GET_USER_ATTENDANCE_SUMMARY_BEGIN](state) {
    state.userAttendanceSummaryState = API_STATES.REQUEST_PENDING
  },
  [types.GET_USER_ATTENDANCE_SUMMARY_SUCCESS](state, summary) {
    state.userAttendanceSummaryError = null
    state.userAttendanceSummary = summary
    state.userAttendanceSummaryState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_USER_ATTENDANCE_SUMMARY_ERROR](state, error) {
    state.userAttendanceSummaryState = API_STATES.REQUEST_ERROR
    state.userAttendanceSummaryError = error
  },

  //cuurent week time-offs request
  [types.GET_CURRENT_WEEK_TIME_OFFS_BEGIN](state) {
    state.currentWeekTimeOffsState = API_STATES.REQUEST_PENDING
  },
  [types.GET_CURRENT_WEEK_OFFS_SUCCESS](state, timeOffRequests) {
    state.currentWeekTimeOffsError = null
    state.currentWeekTimeOffs = timeOffRequests
    state.currentWeekTimeOffsState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_CURRENT_WEEK_OFFS_ERROR](state, err) {
    state.currentWeekTimeOffsState = API_STATES.REQUEST_ERROR
    state.currentWeekTimeOffsError = err
  },

  //next week time-offs request
  [types.GET_NEXT_WEEK_TIME_OFFS_BEGIN](state) {
    state.nextWeekTimeOffsState = API_STATES.REQUEST_PENDING
  },
  [types.GET_NEXT_WEEK_TIME_OFFS_SUCCESS](state, timeOffRequests) {
    state.nextWeekTimeOffsError = null
    state.nextWeekTimeOffs = timeOffRequests
    state.nextWeekTimeOffsState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_NEXT_WEEK_TIME_OFFS_ERROR](state, err) {
    state.nextWeekTimeOffsState = API_STATES.REQUEST_ERROR
    state.nextWeekTimeOffsError = err
  },

  // dropSchedule
  [types.DROP_SCHEDULE_BEGIN](state) {
    state.dropScheduleState = API_STATES.REQUEST_PENDING
  },
  [types.DROP_SCHEDULE_SUCCESS](state,wsr) {
    state.dropScheduleError = null
    const foundSchedule = state.mySchedules.schedules
      .find((s) => (s.id === wsr.wsId))
    foundSchedule && foundSchedule.workScheduleRequests.push(wsr)
    state.refreshMessages = true
    state.dropScheduleState = API_STATES.REQUEST_SUCCESS
  },
  [types.DROP_SCHEDULE_ERROR](state, err) {
    state.dropScheduleState = API_STATES.REQUEST_ERROR
    state.dropScheduleError = err
  },
  // getAvailableShifts
  [types.AVAILABLE_SHIFTS_GET_REQUEST](state) {
    state.availableShiftsGetState = API_STATES.REQUEST_PENDING
  },
  [types.AVAILABLE_SHIFTS_GET_SUCCESS](state, userData) {
    state.availableShiftsGetError = null
    state.availableShifts = userData
    state.availableShiftsGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.AVAILABLE_SHIFTS_GET_ERROR](state, err) {
    state.availableShiftsGetState = API_STATES.REQUEST_ERROR
    state.availableShiftsGetError = err
  },
  [types.AVAILABLE_SHIFTS_UPDATE_REQUEST](state) {
    state.availableShiftsUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.AVAILABLE_SHIFTS_UPDATE_SUCCESS](state,updated) {
    state.availableShiftsUpdateError = null
    const found = (state.availableShifts.availableShiftRequests || [])
      .find((ws)=> ws.workScheduleRequestUsers && ws.workScheduleRequestUsers[0].id === updated.id)
    found &&
    (found.workScheduleRequestUsers[0] =
     Object.assign(found.workScheduleRequestUsers[0],updated))

    state.refreshMessages = !updated.isDenied 
    state.availableShiftsUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.AVAILABLE_SHIFTS_UPDATE_ERROR](state, err) {
    state.availableShiftsUpdateState = API_STATES.REQUEST_ERROR
    state.availableShiftsUpdateError = err
  },

  [types.APPLY_OPEN_SHIFT_REQUEST_BEGIN](state) {
    state.applyOpenShiftState = API_STATES.REQUEST_PENDING
  },
  [types.APPLY_OPEN_SHIFT_SUCCESS](state,message) {
    state.applyOpenShiftError = null
    state.applyOpenShiftState = API_STATES.REQUEST_SUCCESS
    state.applySuccessMessage = message
  },
  [types.APPLY_OPEN_SHIFT_ERROR](state, err) {
    state.applyOpenShiftState = API_STATES.REQUEST_ERROR
    state.applyOpenShiftError = err
  },
  
  [types.CANCEL_OPEN_SHIFT_REQUEST_BEGIN](state) {
    state.cancelOpenShiftState = API_STATES.REQUEST_PENDING
  },
  [types.CANCEL_OPEN_SHIFT_SUCCESS](state,message) {
    state.cancelOpenShiftError = null
    state.cancelOpenShiftState = API_STATES.REQUEST_SUCCESS
    state.cancelSuccessMessage = message
  },
  [types.CANCEL_OPEN_SHIFT_ERROR](state, err) {
    state.cancelOpenShiftState = API_STATES.REQUEST_ERROR
    state.cancelOpenShiftError = err
  },

  [types.CLEAR_ERRORS](state) {
    state.dropScheduleError = null
  },

  // STATS
  [types.GET_DASHBOARD_THIS_WEEK_STATS_BEGIN](state) {
    state.dashboardThisWeekStatsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DASHBOARD_THIS_WEEK_STATS_SUCCESS](state, { statistics }) {
    state.dashboardThisWeekStats = parseToTwoDecimal(statistics)
    state.dashboardThisWeekStatsGetState = API_STATES.REQUEST_SUCCESS
    state.dashboardStatsGetError = null
  },
  [types.GET_DASHBOARD_THIS_WEEK_STATS_FAILED](state, err) {
    state.dashboardThisWeekStatsGetState = API_STATES.REQUEST_ERROR
    state.dashboardStatsGetError = err
  },

  [types.GET_DASHBOARD_ACTUAL_SALES_BEGIN](state) {
    state.actualSalesGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DASHBOARD_ACTUAL_SALES_SUCCESS](state, { statistics }) {
    state.actualSalesByInterval = statistics
    state.actualSalesGetState = API_STATES.REQUEST_SUCCESS
    state.actualSalesGetError = null
  },
  [types.GET_DASHBOARD_ACTUAL_SALES_FAILED](state, err) {
    state.actualSalesGetState = API_STATES.REQUEST_ERROR
    state.actualSalesGetError = err
  },

  [types.GET_DASHBOARD_METRICS_STATS_BEGIN](state) {
    state.dashboardMetricsStatsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DASHBOARD_METRICS_STATS_SUCCESS](state, { statistics, forecastDataLastActivityDate }) {
    state.dashboardMetricsStats = { ...parseToTwoDecimal(statistics), forecastDataLastActivityDate }
    state.dashboardMetricsStatsGetState = API_STATES.REQUEST_SUCCESS
    state.dashboardMetricsStatsGetError = null
  },
  [types.GET_DASHBOARD_METRICS_STATS_FAILED](state, err) {
    state.dashboardMetricsStatsGetState = API_STATES.REQUEST_ERROR
    state.dashboardMetricsStatsGetError = err
  },

  [types.GET_DASHBOARD_LAST_WEEK_STATS_BEGIN](state) {
    state.dashboardLastWeekStatsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DASHBOARD_LAST_WEEK_STATS_SUCCESS](state, { statistics }) {
    state.dashboardLastWeekStats = parseToTwoDecimal(statistics) 
    state.dashboardLastWeekStatsGetState = API_STATES.REQUEST_SUCCESS
    state.dashboardLastWeekStatsGetError = null
  },
  [types.GET_DASHBOARD_LAST_WEEK_STATS_FAILED](state, err) {
    state.dashboardLastWeekStatsGetState = API_STATES.REQUEST_ERROR
    state.dashboardLastWeekStatsGetError = err
  },

  [types.GET_DASHBOARD_HOT_FLOOR_STATS_BEGIN](state) {
    state.dashboardHotFloorStatsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_DASHBOARD_HOT_FLOOR_STATS_SUCCESS](state, { statistics }) {
    state.dashboardHotFloorStats = parseToTwoDecimal(statistics) 
    state.dashboardHotFloorStatsGetState = API_STATES.REQUEST_SUCCESS
    state.dashboardHotFloorStatsGetError = null
  },
  [types.GET_DASHBOARD_HOT_FLOOR_STATS_FAILED](state, err) {
    state.dashboardHotFloorStatsGetState = API_STATES.REQUEST_ERROR
    state.dashboardHotFloorStatsGetError = err
  },

  // REQUESTS
  [types.GET_REQUESTS_BEGIN](state) {
    state.requestsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_REQUESTS_SUCCESS](state, requests) {
    state.requestsGetError = null
    state.requests = requests || []
    state.requestsGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_REQUESTS_FAILED](state, err) {
    state.requestsGetState = API_STATES.REQUEST_ERROR
    state.requestsGetError = err
  },
  
  // SHIFT REQUESTS
  [types.GET_SHIFT_REQUESTS_BEGIN](state) {
    state.shiftRequestsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_SHIFT_REQUESTS_SUCCESS](state, shiftRequests) {
    state.shiftRequestsGetError = null
    state.shiftRequests = shiftRequests || []
    state.shiftRequestsGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_SHIFT_REQUESTS_FAILED](state, err) {
    state.shiftRequestsGetState = API_STATES.REQUEST_ERROR
    state.shiftRequestsGetError = err
  },

  // USER REQUESTS
  [types.GET_USER_REQUESTS_BEGIN](state) {
    state.userRequestsGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_USER_REQUESTS_SUCCESS](state, requests) {
    state.userRequestsGetError = null
    state.userRequests = requests
    state.userRequestsGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_USER_REQUESTS_FAILED](state, err) {
    state.userRequestsGetState = API_STATES.REQUEST_ERROR
    state.userRequestsGetError = err
  },

  // DELETE WORKSCHEDULE REQUEST
  [types.DELETE_WORK_SCHEDULE_REQUEST_BEGIN](state) {
    state.requestDeleteState = API_STATES.REQUEST_PENDING
  },
  [types.DELETE_WORK_SCHEDULE_REQUEST_SUCCESS](state, id) {
    state.requestDeleteError = null
    state.requestDeleteState = API_STATES.REQUEST_SUCCESS
    state.refreshMessages = true
    const index = findIndex(state.requests, { id })
    state.requests.splice(index, 1)

    const updateSchedule = find(state.mySchedules.schedules, {
      workScheduleRequests : [{ id }]
    })
    updateSchedule.workScheduleRequests = []
  },
  [types.DELETE_WORK_SCHEDULE_REQUEST_FAILED](state, err) {
    state.requestDeleteState = API_STATES.REQUEST_ERROR
    state.requestDeleteError = err
  },

  // MESSAGES
  [types.GET_MESSAGES_BEGIN](state) {
    state.messagesGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_MESSAGES_SUCCESS](state, messages) {
    state.messages = messages
    state.refreshMessages = false
    state.messagesGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_MESSAGES_ERROR](state, err) {
    state.messagesGetState = API_STATES.REQUEST_ERROR
    state.refreshMessages = false
    state.messagesGetError = err
  },

  [types.UPDATE_MESSAGE_READ_BEGIN](state) {
    state.messageReadState =  API_STATES.REQUEST_PENDING
    state.messageReadError = null
  },
  [types.UPDATE_MESSAGE_READ_SUCCESS](state,{ message,type }) {
    state.messageReadState =  API_STATES.REQUEST_SUCCESS
    const messageIndex = state[type].messages.list
      .findIndex((m) => m.id===message.id)

    if(~messageIndex) {
      state[type].messages.list[messageIndex] =
      Object.assign(state[type].messages.list[messageIndex],message)
      state[type].messages.unreadMessageCount--
    }
    state.messageReadError = null
  },
  [types.UPDATE_MESSAGE_READ_FAILED](state, err) {
    state.messageReadState =  API_STATES.REQUEST_ERROR
    state.messageReadError = err
  },

  [types.GET_NOTIFICATIONS_BEGIN](state) {
    state.notificationMessagesGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_NOTIFICATIONS_SUCCESS](state, messages) {
    state.notificationMessages = messages
    state.refreshMessages = false
    state.notificationMessagesGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_NOTIFICATIONS_ERROR](state, err) {
    state.notificationMessagesGetState = API_STATES.REQUEST_ERROR
    state.refreshMessages = false
    state.notificationMessagesGetError = err
  },

  [types.UPDATE_MESSAGES_BEGIN](state) {
    state.messageUpdateState =  API_STATES.REQUEST_PENDING
    state.messageUpdateError = null
  },
  [types.UPDATE_MESSAGES_SUCCESS](state,{ message }) {
    state.messageUpdateState =  API_STATES.REQUEST_SUCCESS
    const type = 'messages'
    const messageIndex = state[type].messages.list
      .findIndex((m) => m.id===message.id)

    if(~messageIndex) {
      state[type].messages.list[messageIndex] =
      Object.assign(state[type].messages.list[messageIndex],message)
    }
    state.messageUpdateError = null
  },
  [types.UPDATE_MESSAGES_FAILED](state, err) {
    state.messageUpdateState =  API_STATES.REQUEST_ERROR
    state.messageUpdateError = err
  },

  // SCHEDULED_EMPLOYEES


  [types.GET_SWAPPABLE_EMPLOYEES_BEGIN](state) {
    state.getSwappableEmployeesState = API_STATES.REQUEST_PENDING
  },
  [types.GET_SWAPPABLE_EMPLOYEES_SUCCESS](state, swappableEmployees) {
    state.getSwappableEmployeesError = null
    state.swappableEmployeesData = swappableEmployees
    state.getSwappableEmployeesState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_SWAPPABLE_EMPLOYEES_FAILED](state, err) {
    state.getSwappableEmployeesState = API_STATES.REQUEST_ERROR
    state.getSwappableEmployeesError = err
  },

  // UPDATE WORKSCHEDULE REQUESTS
  [types.UPDATE_WORK_SCHEDULE_REQUEST_BEGIN](state) {
    state.requestUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_WORK_SCHEDULE_REQUEST_SUCCESS](state) {
    state.requestUpdateError = null
    state.requestUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_WORK_SCHEDULE_REQUEST_FAILED](state, err) {
    state.requestUpdateState = API_STATES.REQUEST_ERROR
    state.requestUpdateError = err
  },

  //REMOVE_WORK_SCHEDULE_REQUEST
  [types.REMOVE_WORK_SCHEDULE_REQUEST](state,{ id,wsrType }){
    const filtered =  state.requests.filter((r) => {
      if(wsrType && r.id === id && ['DROP','SWAP'].includes(r.type)) {
        return false
      }
      return r.id !== id
    })
    state.requests = filtered
  },

  // REQUEST TYPES
  [types.GET_REQUEST_TYPES_BEGIN](state) {
    state.requestTypesGetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_REQUEST_TYPES_SUCCESS](state, requestTypes) {
    state.requestTypesGetError = null
    state.requestTypes = requestTypes
    state.requestTypesGetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_REQUEST_TYPES_FAILED](state, err) {
    state.requestTypesGetState = API_STATES.REQUEST_ERROR
    state.requestTypesGetError = err
  },

  // REQUEST TYPES
  [types.DELETE_REQUEST_BEGIN](state) {
    state.deleteRequestsState = API_STATES.REQUEST_PENDING
  },
  [types.DELETE_REQUEST_SUCCESS](state, request) {
    state.deleteRequestsError = null
    state.requests = state.requests.filter(req => req.id !== request.id )
    state.deleteRequestsState = API_STATES.REQUEST_SUCCESS
  },
  [types.DELETE_REQUEST_FAILED](state, err) {
    state.deleteRequestsState = API_STATES.REQUEST_ERROR
    state.deleteRequestsState = err
  },


  // LABOR BUDGET STATS
  [types.GET_LABOR_BUDGET_STATS_BEGIN](state) {
    state.getLaborBudgetState = API_STATES.REQUEST_PENDING
  },
  [types.GET_LABOR_BUDGET_STATS_SUCCESS](state, { punched, scheduled, statistics }) {
    state.getLaborBudgetError = null

    state.laborBudgetStats.punched = punched
    state.laborBudgetStats.scheduled = scheduled
    state.laborBudgetStats.statistics = statistics

    state.getLaborBudgetState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_LABOR_BUDGET_STATS_FAILED](state, err) {
    state.getLaborBudgetState = API_STATES.REQUEST_ERROR
    state.getLaborBudgetError = err
  },

  // STORE INSIGHTS
  [types.GET_STORE_INSIGHTS_STATS_BEGIN](state) {
    state.storeInsightsState = API_STATES.REQUEST_PENDING
  },
  [types.GET_STORE_INSIGHTS_STATS_SUCCESS](state, summary) {
    state.storeInsights = summary
    state.storeInsightsState = API_STATES.REQUEST_SUCCESS
    state.storeInsightsError = null
  },
  [types.GET_STORE_INSIGHTS_STATS_FAILED](state, err) {
    state.storeInsightsState = API_STATES.REQUEST_ERROR
    state.storeInsightsError = err
  },

  // getTodayEMPSchedules
  [types.GET_TODAY_SCHEDULES_BEGIN](state) {
    state.todaySchedulesState = API_STATES.REQUEST_PENDING
  },
  [types.GET_TODAY_SCHEDULES_SUCCESS](state, store) {
    state.todaySchedulesError = null
    state.todaySchedules = store
    state.todaySchedulesState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_TODAY_SCHEDULES_ERROR](state, err) {
    state.todaySchedulesState = API_STATES.REQUEST_ERROR
    state.todaySchedulesError = err
  },

  // getTaskByStatus
  [types.GET_COMPLETED_TASKS_BEGIN](state) {
    state.completedTasksState = API_STATES.REQUEST_PENDING
  },
  [types.GET_COMPLETED_TASKS_SUCCESS](state, store) {
    state.completedTasksStateError = null
    state.completedTasks = store
    state.completedTasksState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_COMPLETED_TASKS_ERROR](state, err) {
    state.completedTasksState = API_STATES.REQUEST_ERROR
    state.completedTasksStateError = err
  },

  // Uncompleted Tasks
  [types.GET_UNCOMPLETED_TASKS_BEGIN](state) {
    state.allUncompletedTasksState = API_STATES.REQUEST_PENDING
  },
  [types.GET_UNCOMPLETED_TASKS_SUCCESS](state, store) {
    state.allUncompletedTasksStateError = null
    state.allUncompletedTasks = store
    state.allUncompletedTasksState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_UNCOMPLETED_TASKS_ERROR](state, err) {
    state.allUncompletedTasksState = API_STATES.REQUEST_ERROR
    state.allUncompletedTasksStateError = err
  },
  // getUnassignedTasks
  [types.GET_UNASSIGNED_TASKS_BEGIN](state) {
    state.allUnassignedTasksState = API_STATES.REQUEST_PENDING
  },
  [types.GET_UNASSIGNED_TASKS_SUCCESS](state, store) {
    state.allUnassignedTasksStateError = null
    state.allUnassignedTasks = store
    state.allUnassignedTasksState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_UNASSIGNED_TASKS_ERROR](state, err) {
    state.allUnassignedTasksState = API_STATES.REQUEST_ERROR
    state.allUnassignedTasksStateError = err
  },

  // getMyTasks
  [types.GET_MY_TASKS_BEGIN](state) {
    state.MyTasksState = API_STATES.REQUEST_PENDING
  },
  [types.GET_MY_TASKS_SUCCESS](state, store) {
    state.MyTasksStateError = null
    state.MyTasks = store
    state.MyTasksState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_MY_TASKS_ERROR](state, err) {
    state.MyTasksState = API_STATES.REQUEST_ERROR
    state.MyTasksStateError = err
  },

  // UpdateMyTasks
  [types.UPDATE_MY_TASK_BEGIN](state,id) {
    state.UpdateTaskRequest.push(id)
    state.UpdateMyTasksState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_MY_TASK_SUCCESS](state, store,id) {
    state.UpdateTaskRequest.splice(state.UpdateTaskRequest.indexOf(id), 1)
    state.UpdateMyStateError = null
    state.UpdateMyTasks = store
    state.UpdateMyTasksState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_MY_TASK_FAILED](state, err,id) {
    state.UpdateTaskRequest.splice(state.UpdateTaskRequest.indexOf(id), 1)
    state.UpdateMyTasksState = API_STATES.REQUEST_ERROR
    state.UpdateMyStateError = err
  },

  // getStoreAssingedTasks
  [types.GET_ASSIGNED_STORE_TASKS_BEGIN](state) {
    state.assignedStoreTasksState = API_STATES.REQUEST_PENDING
  },
  [types.GET_ASSIGNED_STORE_TASKS_SUCCESS](state, store) {
    state.assignedStoreTasksStateError = null 
    state.assignedStoreTasks = store
    state.assignedStoreTasksState = API_STATES.REQUEST_SUCCESS 
  },
  [types.GET_ASSIGNED_STORE_TASKS_ERROR](state, err) {
    state.assignedStoreTasksState = API_STATES.REQUEST_ERROR
    state.assignedStoreTasksStateError = err
  },

  // Store Weather Details
  [types.GET_WEATHER_DETAILS_BEGIN](state) {
    state.weatherDetailsState = API_STATES.REQUEST_PENDING
  },
  [types.GET_WEATHER_DETAILS_SUCCESS](state, data) {
    state.weatherDetailsError = null
    state.weatherDetails = data
    state.weatherDetailsState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_WEATHER_DETAILS_ERROR](state, err) {
    state.weatherDetailsState = API_STATES.REQUEST_ERROR
    state.weatherDetailsError = err.response.data.message
  },

  [types.GET_EMPLOYEE_SCHEDULE_BEGIN](state) {
    state.employeeScheduleRequest = API_STATES.REQUEST_PENDING
  },
  [types.GET_EMPLOYEE_SCHEDULE_SUCCESS](state, data) {
    state.employeeScheduleError = null
    state.employeeSchedule = data
    state.employeeScheduleRequest = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_EMPLOYEE_SCHEDULE_ERROR](state, err) {
    state.employeeScheduleRequest = API_STATES.REQUEST_ERROR
    state.employeeScheduleError = err.response.data.message
  },

  [types.GET_EMPLOYEE_WS_REQUEST_BEGIN](state) {
    state.employeeWSRequestState = API_STATES.REQUEST_PENDING
  },
  [types.GET_EMPLOYEE_WS_REQUEST_SUCCESS](state, data) {
    state.employeeWSRequestError = null
    state.employeeWSRequest = data
    state.employeeWSRequestState = API_STATES.REQUEST_SUCCESS
  },
  [types.GET_EMPLOYEE_WS_REQUEST_ERROR](state, err) {
    state.employeeWSRequestState = API_STATES.REQUEST_ERROR
    state.employeeWSRequestError = err
  },
}

export default mutations
